import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const Header = styled.div`
	display: flex;
	align-items: center;
	column-gap: 16px;
	font-size: ${helpers.font.size.large};
	font-family: ${helpers.font.family.header};
	margin-bottom: 16px;

	> h1, h2, h3, h4, h5 {
		margin: 0;
		padding: 0;
	}

	${mobileMediaQuery(css`
		column-gap: 12px;
	`)}
`
